import qs from 'qs'
import axios from 'axios'

export const elementService = ({
  listElements (token, moduleId) {
    return axios.get('/api/elements?moduleId=' + moduleId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  /*  ,
  getSingleElement (token, elementId) {
    return axios.get('/api/element/single?elementId=' + elementId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.post('/api/element/create', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.put('/api/element/update', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
   */
  deleteElement (token, elementId) {
    return axios.delete('/api/element?elementId=' + elementId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createPostElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.post('/api/element/CreatePostElement', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createNoteElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.post('/api/element/createnote', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createReflectionElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.post('/api/element/createreflection', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createVideoElement (token, formDataObj) {
    return axios.post('/api/element/createvideo', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createDocumentElement (token, formDataObj) {
    return axios.post('/api/element/createdocument', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createChallengeElement (token, formDataObj) {
    return axios.post('/api/element/createchallenge', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updatePostElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.put('/api/Element/UpdatePostElement', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateNoteElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.put('/api/Element/UpdateNote', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateVideoElement (token, formDataObj) {
    return axios.put('/api/Element/UpdateVideo', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateDocumentElement (token, formDataObj) {
    return axios.put('/api/Element/UpdateDocument', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateReflectionElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.put('/api/Element/UpdateReflection', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateChallengeElement (token, formDataObj, isFromCSV = false) {
    return axios.put('/api/Element/UpdateChallenge?isFromCSV=' + isFromCSV, formDataObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  createMCQElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.post('/api/element/createmcq', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateMCQElement (token, elementObj, isFromCSV = false) {
    var stringifiedObj = JSON.stringify(elementObj)
    return axios.put('/api/Element/UpdateMCQ?isFromCSV=' + isFromCSV, stringifiedObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  reIndexElements (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.put('/api/Element/ReIndexElements', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSingleElement (token, elementId) {
    return axios.get('/api/Element/Single?elementId=' + elementId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateMcqOptionImage (token, formDataObj) {
    return axios.put('/api/Element/UploadMCQOptionImage', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteMcqOptionImage (token, optionId) {
    return axios.delete('/api/Element/RemoveMCQOptionImage?optionId=' + optionId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createAdaptiveGameElement (token, formDataObj) {
    return axios.post('/api/element/CreateAdaptiveGame', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateAdaptiveGameElement (token, formDataObj) {
    // var stringifiedObj = qs.stringify(elementObj)
    return axios.put('/api/Element/UpdateAdaptiveGame', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  associateAdaptiveGameElements (token, dataObj) {
    // var stringifiedObj = qs.stringify(dataObj)
    return axios.put('/api/Element/AssociateAdaptiveGameElements', dataObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  getAdaptiveGameStepElements (token, moduleId) {
    return axios.get('/api/Elements?moduleId=' + moduleId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAdaptiveGamePath (token, elementId) {
    return axios.get('/api/Element/AdaptiveGamePaths?elementId=' + elementId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  resetAdaptiveGamePath (token, elementId) {
    return axios.put('/api/Element/ResetAdaptiveGame?elementId=' + elementId, null, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  createMissionGameElement (token, formDataObj) {
    return axios.post('/api/Mission/CreateMission', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  copyOpeningQuestion (token, elementId) {
    return axios.post('/api/Mission/CopyOpeningQuestions?elementId=' + elementId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMissionCheckinWithCourseJourney (token, elementId, includeCourseJourney = true) {
    return axios.get('/api/Mission/MissionCheckIns?elementId=' + elementId + '&includeCourseJourney=' + includeCourseJourney, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createMissiomCheckIns (token, elementObj) {
    return axios.post('/api/Mission/CreateMissionCheckin', elementObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteMissionCheckIn (token, missionCheckInId) {
    return axios.delete('/api/Mission/DeleteMissionCheckIn?missionCheckInId=' + missionCheckInId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateMissionCheckIn (token, dataObj) {
    return axios.put('/api/Mission/UpdateMissionCheckIn', dataObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  updateMissionGameElement (token, formDataObj) {
    return axios.put('/api/Mission/UpdateMission', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getLearningLevels (token) {
    return axios.get('/api/LearningLevels', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createAssessmentElement (token, dataObj) {
    return axios.post('/api/Element/CreateAssessmentElement', dataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateAssessmentElement (token, dataObj) {
    return axios.put('/api/Element/UpdateAssessmentElement', dataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  reIndexAssessmentElements (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.put('/api/Element/ReIndexElementsForAssessment', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  }
})

/* Element Object Params - Use the below object structure while POSTing/PUTting the object to apis
  {
  };
*/



// WEBPACK FOOTER //
// ./src/server-util/element-service.js